import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

// Network failures on GETs: flag a shared error state (rendered by Layout) and reject with err.netHandled,
// so widgets can show their own error; unhandled ones are silenced below.
const netSubs = new Set();
let netError = false;
const setNetError = (v) => {
  netError = v;
  netSubs.forEach((f) => f());
};
export const netErrorStore = {
  subscribe: (f) => (netSubs.add(f), () => netSubs.delete(f)),
  get: () => netError,
  clear: () => setNetError(false),
};

api.interceptors.response.use(undefined, (err) => {
  const cfg = err.config || {};
  if (err.response?.status === 402) window.dispatchEvent(new Event("jatak-locked"));
  if (!err.response && !axios.isCancel(err) && (cfg.method || "get") === "get") {
    err.netHandled = true;
    if (cfg.netGuard !== false) setNetError(true);
  }
  return Promise.reject(err);
});

window.addEventListener("unhandledrejection", (e) => {
  if (e.reason && e.reason.netHandled) e.preventDefault();
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("jatak_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if ((config.method || "get") === "get" && !config.timeout) config.timeout = 20000;
  return config;
});

export function apiError(detail) {
  if (detail == null) return "Noget gik galt. Prøv igen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
